import VerifyEmailAuth from "modules/auth/VerifyEmail";

const VerifyEmail = () => {
  return <VerifyEmailAuth />
};

export default VerifyEmail;